import {FormattedMessage} from "react-intl";
import {Swiper, SwiperSlide} from "swiper/react";
import classNames from "classnames/bind";
import styles from "./index.module.scss";
import "swiper/swiper-bundle.min.css";

const cn = classNames.bind(styles);

function View({
  swiper,
  setSwiper,
  slideHeight,
  firstSlideRef,
  handleSlideHeight,
  getHelpImg,
  showReplayOption,
  onClickDoNotShow,
  onClickClose,
}) {
  return (
    <div className={cn("helper_popup")} onClick={onClickClose}>
      <div className={cn("tip_text")}>
        <span>
          <strong>TIP</strong>Avoid the running cars, solve the puzzle
        </span>
        <span>to arrive at the Donut Shop as fast as you can!</span>
      </div>
      <div className={cn("helper_img")}>
        <Swiper
          className={cn("tutorial_slide")}
          slidesPerView={"auto"}
          pagination={{
            el: ".pagination",
            type: "fraction",
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
          }}
          onSwiper={setSwiper}
        >
          <SwiperSlide className={cn("img")}>
            <img alt="help img" src={getHelpImg()} ref={firstSlideRef} onLoad={handleSlideHeight} />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

export default View;
